import { EMPTY_OBJECT } from '../constants/common'
import { INHABITANT_ENTITY } from '../constants/entity'
import {
  USER_INHABITANT_PROFILE_OPTIONS_API_PARAMS,
  USER_MANAGER_PROFILE_OPTIONS_API_PARAMS,
  USER_PROPERTY_OWNER_PROFILE_OPTIONS_API_PARAMS,
  USER_REQUEST_APPLICANT_PROFILE_OPTIONS_API_PARAMS,
  USER_SUPPLIER_PROFILE_OPTIONS_API_PARAMS,
  USER_WORKER_PROFILE_OPTIONS_API_PARAMS,
} from '../constants/user'
import { deleteApi, getApi, patchApi, postApi } from '../utils/api'

export function archiveUserProfiles({ ids, options }) {
  return deleteApi({
    data: { model: 'Profile', model_pks: JSON.stringify(ids) },
    endpoint: `api/mass_action/`,
    options,
  })
}

export function createProfileContact({ data, id, options }) {
  return postApi({
    data,
    endpoint: `api/profile/${id}/profile-contact/`,
    options,
  })
}

export function getCurrentProfile() {
  return getApi({ endpoint: 'idwell-api/api/v3/profile/current/' })
}

export function deleteExternalContactProfile({ id, options }) {
  return deleteApi({ endpoint: `api/external-contact/${id}/`, options })
}

export function deleteProfileContact({ contactId, options }) {
  return deleteApi({
    endpoint: `api/profile-contact/${contactId}/`,
    options,
  })
}

export function editProfileContact({ contactId, data, options }) {
  return patchApi({
    data,
    endpoint: `api/profile-contact/${contactId}/`,
    options,
  })
}

export function getExternalContactProfile({ id, options }) {
  return getApi({
    endpoint: `api/v2/user-profile/external-contacts/${id}/`,
    options,
  })
}

export function getInhabitantProfile({ id, options }) {
  return getApi({ endpoint: `api/profile/${id}/`, options })
}

export function getPreferredCommunicationOptions({
  options,
  params,
} = EMPTY_OBJECT) {
  return getApi({ endpoint: `api/preferred-communication/`, options, params })
}

export function getProfileContacts({ id, options }) {
  return getApi({ endpoint: `api/profile/${id}/profile-contact/`, options })
}

export function getProfileContactTypes({ id, options }) {
  return getApi({ endpoint: `api/profile/${id}/contact-type/`, options })
}

export function getSalutationOptions({ options, params }) {
  return getApi({ endpoint: `api/salutation/`, options, params })
}

export function getUkCurrencyOptions({ options } = EMPTY_OBJECT) {
  return getApi({ endpoint: `api/uk/currency/`, options })
}

export function getUserProfileOptions(params) {
  return getApi({
    endpoint: `idwell-api/api/v3/profile/profile-options/`,
    params,
  })
}

export function getInhabitantProfileOptions(params) {
  return getUserProfileOptions({
    ...params,
    ...USER_INHABITANT_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function getDwellerListOptions({
  search,
  ...restParams
} = EMPTY_OBJECT) {
  return getApi({
    endpoint: 'api/dweller-list-options/',
    params: {
      ...restParams,
      ...(search ? { fullname_or_email: search } : null),
      is_landlord: true,
      soft_archived: false,
    },
  })
}

export function getManagerListOptions({
  search,
  ...restParams
} = EMPTY_OBJECT) {
  return getApi({
    endpoint: 'api/manager-list-options/',
    params: {
      ...(search ? { fullname_or_email: search } : null),
      ...restParams,
    },
  })
}

export function getManagerProfileOptions(params) {
  return getUserProfileOptions({
    ...params,
    ...USER_MANAGER_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function getPropertyOwnerProfileOptions(params) {
  return getUserProfileOptions({
    ...params,
    ...USER_PROPERTY_OWNER_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function getRequestApplicantProfileOptions(params) {
  return getUserProfileOptions({
    ...params,
    ...USER_REQUEST_APPLICANT_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function getSupplierProfileOptions(params) {
  return getUserProfileOptions({
    ...params,
    ...USER_SUPPLIER_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function getWorkerProfileOptions(params) {
  return getUserProfileOptions({
    ...params,
    ...USER_WORKER_PROFILE_OPTIONS_API_PARAMS,
  })
}

export function getUserProfile({ id, options }) {
  return getApi({
    endpoint: `api/v2/user-profile/user-profiles/${id}/`,
    options,
  })
}

export function getUserProfileInfo({ id, options }) {
  return getApi({ endpoint: `api/profile/${id}/info/`, options })
}

export function inviteInhabitant({ data, options }) {
  return postApi({ data, endpoint: `api/profile/invite/`, options })
}

export function performInhabitantsMassAction({ data, options }) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/inhabitancy/${INHABITANT_ENTITY.plural}/mass-action/`,
    options,
  })
}

export function reinviteUserProfiles({ data, ids, options }) {
  return postApi({
    data: { ...data, reinvite: true, users: JSON.stringify(ids) },
    endpoint: `api/profile/invite/`,
    options,
  })
}

export function restoreUserProfiles({ ids, options }) {
  return patchApi({
    data: {
      model: 'Profile',
      model_pks: JSON.stringify(ids),
      patch: { soft_archived: false },
    },
    endpoint: `api/mass_action/`,
    options,
  })
}

export function setStaffMemberBuildings({ data, id, options }) {
  return postApi({
    data,
    endpoint: `api/profile/manager/${id}/set-buildings/`,
    options,
  })
}

export function setStaffMemberCategories({ data, id, options }) {
  return postApi({
    data,
    endpoint: `api/profile/manager/${id}/set-categories/`,
    options,
  })
}

export function updateExternalContactProfile({ data, id, options }) {
  return patchApi({
    data,
    endpoint: `api/v2/user-profile/external-contacts/${id}/`,
    options,
  })
}

export function updateInhabitantAddress({ id, options, value }) {
  return patchApi({
    data: { flats: value },
    endpoint: `api/profile-tiny/${id}/`,
    options,
  })
}

export function updateUserProfile({ data, id, options }) {
  return patchApi({
    data,
    endpoint: `api/v2/user-profile/user-profiles/${id}/`,
    options,
  })
}

export function updateUserProfileInfo({ data, id, options }) {
  return patchApi({ data, endpoint: `api/profile/${id}/info/`, options })
}
